<body>
  <div class="partical_all">
    <div id="stars"></div>
    <div id="stars2"></div>
    <div id="stars3"></div>
    <div id="particle-container">
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
    </div>
  </div>
  <!--<canvas id="canvas" width="1000px" height="1000px"></canvas>-->
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-lg-4">
        <div class="logo">
          <img
            src="{{ onPassiveBaseUrl }}onpassive(nov10)/images/logo_one.png"
            alt="logo"
          />
        </div>
      </div>
    </div>
    <div class="row align-items-center top">
      <div class="col-lg-4 mid">
        <div class="left_first_box">
          <h1 class="c-article__title">
            NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS
          </h1>
          <div class="video_box acc_panel anim_in">
            <video
              id="my-video"
              class="video-js video-size w-100 h-auto"
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
      <div class="col-lg-4 first">
        <div class="mid_box">
         
          <div class="globe_main">
            <div class="ai_image">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(nov10)/images/ai.png"
                alt="image"
              />
            </div>
          </div>
          <div class="light">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(nov10)/images/light.png"
              alt="image"
            />
          </div>
          <div class="bottom_image">
            <img
              src="{{
                onPassiveBaseUrl
              }}onpassive(nov10)/images/bottom_image.png"
              alt="image"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="right_box">
          <div class="launching_box">
            <div class="launching_box_one">
            
              <h1 class="ml12">LAUNCHING SOON!</h1>
            </div>
            <div class="text_box">
              <div class="slider">
                <p>
                  Are you here because somebody just mentioned ONPASSIVE is a
                  great business platform? They're right, We are! At ONPASSIVE
                  we are constantly working on streamlining growth of several
                  businesses online. With Artificial Intelligence by our side,
                  we can put a spotlight on your business by providing some of
                  the best internet marketing solutions for the whole world to
                  see
                </p>
              </div>
            </div>

            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              target="_blank"
              rel="noopener"
              class="btn11"
            >
              <span>BECOME A FOUNDER NOW</span>
              <div class="transition"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
